import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home/Index.vue'
import Page from './views/Post.vue'
import Contact from './views/Contact/Index.vue'
import EventClass from './views/EventClass/Index.vue'
import Event from './views/Event/Index.vue'
import EventDetail from './views/Event/Detail.vue'
import Video from './views/Video/Index.vue'
import VideoDetail from './views/Video/Detail.vue'
import Accessories from './views/Accessories/Index.vue'
import AccessoryDetail from './views/Accessories/Detail.vue'
import PageCategory from './views/Product/Category.vue'
import ProductDetail from './views/Product/Detail.vue'
import Search from './views/Search/Index.vue'
import XildaClass from './views/OutStory/XildaClass'
import XildaStory from './views/OutStory/XildaStory'
import BlogDetail from './views/OutStory/BlogDetail'
import XildaAmbassador from './views/OutStory/XildaAmbassador'
import XildaMaster from './views/OutStory/XildaMaster'
import PeopleDetail from './views/OutStory/PeopleDetail'
import XildaNetwork from './views/OutStory/XildaNetwork'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:lang',
      name: 'Home',
      component: Home
    },
    {
      path: '/:lang/home',
      name: 'withHome',
      component: Home
    },
    {
      path: '/:lang/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/:lang/our-story/xilda-class',
      name: 'XildaClass',
      component: XildaClass
    },
    {
      path: '/:lang/our-story/xilda-story',
      name: 'XildaStory',
      component: XildaStory
    },
    {
      path: '/:lang/our-story/xilda-ambassador',
      name: 'XildaAmbassador',
      component: XildaAmbassador
    },
    {
      path: '/:lang/our-story/xilda-master',
      name: 'XildaMaster',
      component: XildaMaster
    },
    {
      path: '/:lang/our-story/xilda-network',
      name: 'XildaNetwork',
      component: XildaNetwork
    },
    {
      path: '/:lang/blog/:slug',
      name: 'BlogDetail',
      component: BlogDetail
    },
    {
      path: '/:lang/people/:slug',
      name: 'PeopleDetail',
      component: PeopleDetail
    },
    {
      path: '/:lang/event-class',
      name: 'EventClass',
      component: EventClass
    },
    {
      path: '/:lang/event',
      name: 'EventLanding',
      component: Event
    },
    {
      path: '/:lang/event/:slug',
      name: 'event',
      component: EventDetail
    },
    {
      path: '/:lang/video',
      name: 'VideoLanding',
      component: Video
    },
    {
      path: '/:lang/video/:slug',
      name: 'video',
      component: VideoDetail
    },
    {
      path: '/:lang/accessories',
      name: 'AccessoriesLanding',
      component: Accessories
    },
    {
      path: '/:lang/accessories/:slug',
      name: 'accessories',
      component: AccessoryDetail
    },
    {
      path: '/:lang/product/:slug',
      name: 'product',
      component: ProductDetail
    },
    {
      path: '/:lang/search/:query',
      name: 'Search',
      component: Search
    },
    {
      path: '/:lang/:category/:slug',
      name: 'PageCategory',
      component: PageCategory
    },
    {
      path: '/:lang/:slug',
      name: 'Page',
      component: Page
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
